import {
  RECURRING_MERCHANT_FAILED,
  RECURRING_MERCHANT_LOADING,
  RECURRING_MERCHANT_REMOVE,
  RECURRING_MERCHANT_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  error: null as null | string,
  status: null as null | number,
  data: null as any,
  request: null as null | "post" | "delete",
};

export const recurringMerchantReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case RECURRING_MERCHANT_LOADING:
      return { ...state, loading: true };
    case RECURRING_MERCHANT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        status: action.status,
        error: null,
        request: action.request,
      };
    case RECURRING_MERCHANT_FAILED:
      return {
        ...state,
        loading: false,
        status: action.status,
        error: action.error,
        request: action.request,
      };
    case RECURRING_MERCHANT_REMOVE:
      return initialState;
    default:
      return state;
  }
};
